"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Calculator = exports.calculateValues = exports.transformLayoutValues = void 0;
const transformLayoutValues = (value, multiplier = 1) => {
    if (typeof value === 'string') {
        const strArr = value.split(/(\d+)/).filter(Boolean);
        if (!+strArr[0])
            return value;
        const _value = +strArr[0] * multiplier;
        return `${_value}${strArr[1]}`;
    }
    if (typeof value === 'number') {
        return value * multiplier;
    }
    return value;
};
exports.transformLayoutValues = transformLayoutValues;
const calculateValues = (value1, value2, 
// eslint-disable-next-line no-unused-vars
callback) => {
    if (typeof value1 === 'string' && typeof value2 === 'string') {
        const val1StrArr = value1.split(/(\d+)/).filter(Boolean);
        const val2StrArr = value2.split(/(\d+)/).filter(Boolean);
        const ans = callback(+val1StrArr[0] || 0, +val2StrArr[0] || 0);
        return `${ans}${val1StrArr[1]}`;
    }
    if (typeof value1 === 'string' && typeof value2 === 'number') {
        const val1StrArr = value1.split(/(\d+)/).filter(Boolean);
        const ans = callback(+val1StrArr[0] || 0, value2);
        return `${ans}${val1StrArr[1]}`;
    }
    if (typeof value1 === 'number' && typeof value2 === 'string') {
        const val2StrArr = value2.split(/(\d+)/).filter(Boolean);
        const ans = callback(value1, +val2StrArr[0] || 0);
        return `${ans}${val2StrArr[1]}`;
    }
    return callback(value1, value2);
};
exports.calculateValues = calculateValues;
class Calculator {
    static add(value1, value2) {
        return value1 + value2;
    }
    static sub(value1, value2) {
        return value1 - value2;
    }
}
exports.Calculator = Calculator;
//# sourceMappingURL=transform-layout-values.js.map